import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';

import { AddressItemComponent } from './address-item/address-item';
import { AddressWriteComponent } from './address-write/address-write';
import { HousingUnitItemComponent } from './housing-unit-item/housing-unit-item';
import { MessageItemComponent } from './message-item/message-item';
import { NgModule /*, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA*/ } from '@angular/core';
import { UserAddComponent } from './user-add/user-add';
import { UserItemComponent } from './user-item/user-item';
import { CondominiumItemComponent } from './condominium-item/condominium-item';
import { DeviceItemComponent } from './device-item/device-item';
import { FrequencyBarGraphComponent } from './frequency-bar-graph/frequency-bar-graph';
import { CallComponent } from './call/call';
import { MessageListComponent } from './message-list/message-list';
import { AddressListComponent } from './address-list/address-list';

@NgModule({
	declarations: [
		AddressWriteComponent,
		AddressItemComponent,
		CallComponent,
		CondominiumItemComponent,
		DeviceItemComponent,
		FrequencyBarGraphComponent,
		HousingUnitItemComponent,
		MessageItemComponent,
		MessageListComponent,
		UserAddComponent,
		UserItemComponent,
    AddressListComponent,
	],
	imports: [
		CommonModule,
		IonicModule
	],
	exports: [
		AddressWriteComponent,
		AddressItemComponent,
		CallComponent,
		CondominiumItemComponent,
		DeviceItemComponent,
		FrequencyBarGraphComponent,
		HousingUnitItemComponent,
		MessageItemComponent,
		MessageListComponent,
		UserAddComponent,
		UserItemComponent,
    AddressListComponent,
	]
	/*
	,
	schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
	*/
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts